<template>
	<div class="goodsview">
		<div @click="ActionFun($event)">
			<slot name="title">添加</slot>
		</div>

		<VsModal width="1000px" top="80" style="min-height: 600px" v-model="modelstep" @on-confirm="fnModelConfirm">
			<div slot="header">
				<span>客户信息</span>
			</div>
			<div slot="content" v-cloak class="okgoodsview">
				<div class="modelbox">
					<div class="itemleft">
						<div class="infowrap">
							<li class="itemwrap">
								<div style="position: relative">
									<span
										style="position: absolute;color: red;font-size: 20px;left: -10px;top: 4px;">*</span>
									<span class="oSpan">店铺信息：</span>
									<Select v-model="infolist.FDID" style="width: 188px">
										<Option v-for="item in FDlist" :value="item.FDID" :key="item.FDMC">
											{{ item.FDMC }}
										</Option>
									</Select>
								</div>
							</li>
						</div>
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<Vsinput lable="客户名称" v-model="infolist.KHMC" width="188" validation="true">
								</Vsinput>
							</li>
						</div>
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<Vsinput lable="手机" type="number" v-model="infolist.Phone1" lablewidth="188" width="188"
									@input="infolist.LoginName=infolist.Phone1" validation="true"></Vsinput>
							</li>
						</div>
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<VsAreaPicker lable="城市" v-model="infolist.City" width="188" validation="true" readonly=false>
								</VsAreaPicker>
							</li>
						</div>
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<Vsinput lable="详细地址" v-model="infolist.Address" width="188" >
								</Vsinput>
							</li>
						</div>
						<div class="infowrap" v-show="!info" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<Vsinput lable="登录名" v-model="infolist.LoginName" width="188" >
								</Vsinput>
							</li>
						</div>
						<div class="infowrap" style="display: flex">
							<li class="itemwrap">
								<RadioGroup v-model="infolist.CustomerType">
									<Radio :label="0"   :checked="infolist.CustomerType==0">普通客户</Radio>
									<Radio :label="1"  :checked="infolist.CustomerType==1">分销客户</Radio>
									
								</RadioGroup>
							</li>
						</div>
					</div>
					<!-- <div class="infowrap" v-if="!info" @keyup.enter="enterToTab()">
						<li class="itemwrap">
							<Vsinput lable="密码" v-model="infolist.Pwd" width="188" validation="true"></Vsinput>
						</li>
					</div> -->
					<div class="itemright">
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<InputJGSelect lable="价格类型" width="188" returnkey="name" v-model="infolist.PriceType"
									validation="true">
								</InputJGSelect>
							</li>
						</div>
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<Vsinput lable="期初金额" type="number" v-model="infolist.Balance" width="188"
									>
								</Vsinput>
							</li>
						</div>
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<InputYGSelect lable="所属业务员" width="188" v-model="infolist.ZGID"  :selectText="infolist.ZGMC" returnkey="ZGMC"
									@on-select="fnCreatSalesMan" validation="true">
								</InputYGSelect>
							</li>
							<i class="iconfont icontianjia1" style="font-size: 19px" @click="toJump()"></i>
						</div>
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<Vsinput lable="联系人" v-model="infolist.Linkman" width="188"></Vsinput>
							</li>
						</div>
					</div>
				</div>
				<div class="modelbox">
					<div class="itemleft">
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<Vsinput lable="税号" v-model="infolist.TFN" lablewidth="80" width="188"></Vsinput>
							</li>
						</div>
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<Vsinput lable="银行账户" type="number" v-model="infolist.IBAN" lablewidth="80" width="188">
								</Vsinput>
							</li>
						</div>
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<Vsinput lable="开户行" v-model="infolist.BankOfDeposit" lablewidth="80" width="188">
								</Vsinput>
							</li>
						</div>
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<Vsinput lable="官网" v-model="infolist.WebSite" lablewidth="80" width="188"></Vsinput>
							</li>
						</div>
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<Vsinput lable="说明" v-model="infolist.Remark" lablewidth="80" width="188"></Vsinput>
							</li>
						</div>
					</div>
					<div class="itemright">
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<div>
									<span class="oSpan">公司性质：</span>
									<Select v-model="infolist.CompanyNature" style="width:188px;margin:5px;7">
										<Option v-for="item in cityList" :value="item.value" :key="item.value">
											{{ item.label }}
										</Option>
									</Select>
								</div>
							</li>
						</div>
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<Vsinput lable="常用物流" v-model="infolist.CommonLogistics" lablewidth="80" width="188">
								</Vsinput>
							</li>
						</div>
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<div>
									<span
										style="font-size: 14px;font-family: Microsoft YaHei;font-weight: bold;color: rgba(51, 51, 51, 1);">
										生日：
									</span>
									<el-date-picker style="width: 199px; padding: 5px" v-model="infolist.Birthday"
										type="date" size="large" placeholder="选择日期" value-format="yyyy-MM-dd">
									</el-date-picker>
								</div>
							</li>
						</div>
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<Vsinput lable="信用额度" type="number" v-model="infolist.CreditLine" lablewidth="80"
									width="188"></Vsinput>
							</li>
						</div>
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<Vsinput lable="积分比例" type="number" v-model="infolist.LimitOfIntegral" lablewidth="80"
									width="188"></Vsinput>
							</li>
							<li class="itemwrap">							
								<el-switch
								  style="display: block"
								  v-model="infolist.IsIntegral"
								  active-color="#13ce66"
								  inactive-color="#ff4949"
								  :active-value=1
								  :inactive-value=0
								  >
								</el-switch>
							
								<Vsinput lable="初始积分" type="number" v-if="infolist.IsIntegral==1" v-model="infolist.InitIntegral" lablewidth="80"
									width="188"></Vsinput>
							</li>
						</div>

						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<Vsinput lable="电话1" type="number" v-model="infolist.Mobile" lablewidth="80"
									width="188">
								</Vsinput>
							</li>
						</div>
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<Vsinput lable="电话2" v-model="infolist.Phone2" lablewidth="80" width="188"></Vsinput>
							</li>
						</div>
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<Vsinput lable="QQ" type="number" v-model="infolist.QQ" lablewidth="80" width="188">
								</Vsinput>
							</li>
						</div>
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<Vsinput lable="邮箱" v-model="infolist.Email" lablewidth="80" width="188"></Vsinput>
							</li>
						</div>
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<Vsinput lable="支付宝" type="number" v-model="infolist.Alipay" lablewidth="80"
									width="188">
								</Vsinput>
							</li>
						</div>
						<div class="infowrap" @keyup.enter="enterToTab()">
							<li class="itemwrap">
								<Vsinput lable="微信" v-model="infolist.WeChat" lablewidth="80" width="188"></Vsinput>
							</li>
						</div>
					</div>
				</div>
				<div class="imgbox">
					<div class="imgwrap">
						<div class="imgicon">
							<li class="delate" @click="delateurl">
								<Icon type="ios-close-circle-outline" />
							</li>
							<li class="imgitem" :style="{background: 'url(' + mergedImgs + ') no-repeat center'}">
								<input type="file" @change="fang" :src="mergedImgs" @mouseover="bigImg($event)" @mouseout="hideImg($event)"/>
							</li>
						</div>
						<div class="addinput" v-if="mergedImgs !== '' ? false : true">
							<input class="inputs" type="file" @change="fang" />
						</div>
					</div>
				</div>
			</div>
			<div class="btnwrap" slot="footer">
				<Button @click="modelstep = false" type="default" size="large" style="width: 80px">取消</Button>
				<Button @click="fnModelConfirm" type="primary" size="large"
					style="background: #2d8cf0; margin: 0 20px; width: 100px">
					确定
				</Button>
			</div>
		</VsModal>
		
		<img :src="imgSrc" v-show="imgShow" style="width: 300px; height: auto; position: absolute; left: 100px; top: 0; z-index: 99999999"/>
	</div>
</template>

<script>
	import InputJGSelect from "./InputJGSelect.vue";
	import InputYGSelect from "./InputYGSelect.vue";
	
	import pinyin  from '../../../assets/js/pinyin.js'
	export default {
		props: {
			info: {},
			category: {},
		},
		components: {
			InputJGSelect,
			InputYGSelect,
		},
		data() {
			return {
				imgShow: false, // 大图展示
				imgSrc: '', 
				lablewidth: "100",
				modelstep: false,
				imgurls: [],
				FDlist: [], // 分店信息

				infolist: {
					ROOT: "", //必输项类别编号
					KHMC: "", //	 必输项
					Pwd: "123", // 必输项 密码
					LoginName: "", //	 必输项 分配用户名

					FDID: "", // 分店ID
					FDMC: "分店4", // 分店名字

					Address: "", //详细地址
					City: "河南省;郑州市;中原区", //城市
					Alipay: "", // 支付宝
					Balance: "0", // 余额
					BankOfDeposit: "", //开户行
					Birthday: "", //	 生日
					CommonLogistics: "", // 常见物流
					CompanyNature: "", //	 公司性质
					CustomerType: 0, // 分销客户1，普通客户0
					Email: "",
					IBAN: "", //	 银行账号
					IsIntegral: 1, // 是否参与积分
					LimitOfIntegral: "", //	 积分比例
					InitIntegral:0,//初始积分
					Linkman: "", //
					Mobile: "", // 移动电话
					Phone1: "", //	 电话1
					Phone2: "", // 电话2
					PriceType: "自动价", //	 必输项 价格类型
					QQ: "",
					Remark: "", // 附加说明
					TFN: "", // 税号
					WebSite: "", // 官网
					WeChat: "", // 微信
					CreditLine: "0", //0 信用额度
					HeadPhoto: [], //客户头像
					IDCard: "",
					ZGID: "", //业务员ID
					ZGMC: "", //业务员名字
					
				},
				//选中业务员信息
				ZGList:{
					ZGID: "", //业务员ID
					ZGMC: "", //业务员名字
				},
				cityList: [{
						value: "私营",
						label: "私营",
					},
					{
						value: "国有",
						label: "国有",
					},
					{
						value: "合资",
						label: "合资",
					},
					{
						value: "外资",
						label: "外资",
					},
					{
						value: "股份",
						label: "股份",
					},
					{
						value: "其它",
						label: "其它",
					},
				],
				newfile: "",
			};
		},
		computed: {
			mergedImgs: {
				get: function() {
					var arr = "";
					if (this.infolist.IDCard) {
						arr = this.infolist.IDCard;
						console.log("true");
					} else {
						console.log("false");
						this.imgurls.forEach((v) => {
							arr = v.imgurl;
						});
					}
					return arr;
				},
				set: function() {
					console.log("set");
				},
			},
		},
		
		mounted() {
			if (this.info) {
				
				this.infolist = this.info;
				this.infolist.IsIntegral=parseInt(this.infolist.IsIntegral);
				console.log(this.infolist.IsIntegral);
			}

			// 获取 分店信息  ErpGetFDInfo
			this.fnGetFDinfo();
		},
		methods: {
			bigImg($event) {
			        this.imgShow = true
			        this.imgSrc = $event.target.src
			},
			hideImg($event){
			       this.imgSrc = ''
			       this.imgShow = false
			},
			
			toJump() {
				this.$router.replace({
					name: "ZGInfo",
					params: {
						values: true
					}
				});
			},
			enterToTab() {
				this.$nextTick(() => {
					let inpNub = document.querySelector(".tabs-content").querySelectorAll("input")
					const len = inpNub.length;
					for (let i = 0; i < len; i++) {
						inpNub[i].addEventListener("keydown", (e) => {
							if (e.keyCode === 13) {
								const nextInput = inpNub[i + 1];
								nextInput && nextInput.focus();
							}
						});
					}
				});
			},

			// 获取 分店信息  ErpGetTeshuFD
			fnGetFDinfo() {
				let params = this.$fun.GetUserConstant();
				(params.CKMC = ""),
				this.$Api.ErpGetTeshuFD(params).then((res) => {
					// console.log("获取分店返回数据:------");
					// console.log(res);
					if (res.status == "SUCCESS") {
						this.FDlist = res.data.fd
						if (res.data.fd.length == 1) {
							this.infolist.FDID = res.data.fd[0].FDID
							this.infolist.FDMC = res.data.fd[0].FDMC
						}
					} else {
						this.$Message.warning({
							content: res.msg,
							background: true
						});
					}
				});
			},

			fnSetval(e) {
				this.infolist.PriceType = e.name;
			},

			ActionFun($event) {
				console.log("触发触发 触发  触发:---------------------------")
				this.modelstep = !this.modelstep;
				console.log(JSON.stringify(this.info))
				if (this.info) {
					this.infolist = this.info;
					this.ZGList.ZGID=this.infolist.ZGID;
					this.ZGList.ZGMC=this.infolist.ZGMC;
				}
				if (this.category) {
					this.infolist.leibie = this.category.name;
					this.infolist.ROOT = this.category.CategoryID;
				}
			},

			// 添加客戶信息
			fnCreatUserInfo() {
				let userinfo = this.$fun.GetUserConstant();
				delete userinfo.LoginName;
				if (!this.info) {
					userinfo.ROOT = this.category.CategoryID;
				}
				let params = Object.assign({}, this.infolist, userinfo);
				if (params.ZGID == "" && params.ZGMC == "") {
					params.ZGID = "无";
					params.ZGMC = "无";
				}
				params.IsIntegral=parseInt(params.IsIntegral);
				console.log("新的客户信息参数:---------------");
				console.log(JSON.stringify(params))
				if (this.info) {
					this.$Api.ErpKHinfoUpdate(params).then((res) => {
						if (res.status == "SUCCESS") {
							this.$Message.success(res.msg);
							this.$emit("on-confirm");
						} else {
							this.$Message.error(res.msg);
							this.$emit("on-confirm");
						}
					});
					this.modelstep = false;
				} else {
					this.$Api.ErpAddKHInfo(params).then((res) => {
						console.log(res)
						if (res.status == "SUCCESS") {
							this.$emit("on-confirm");
							if (!this.info) {
								Object.keys(this.infolist).forEach((v) => {
									if (v == 'PriceType' || v=='Pwd') {

									} else {
										this.infolist[v] = "";
									}
								});
							}
							this.$Message.success(res.msg);
						} else {
							this.$Message.error(res.msg);
							this.$emit("on-confirm");
						}
					})
				}
			},
 filterStr(str){
            let that = this;
            var specialStr = "";
		for(var i=0;i<str.length;i++){
	        specialStr += str.substr(i, 1).replace(/[`~!@#$^&*()=|{}':;',\[\].<>\/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？%+_]/, ''); 
        }
	    return specialStr;
   } ,
			//提交数据
			fnModelConfirm() {
				let newinfo = this.infolist;
				let reg = /^1[0-9]{10}$/;
				if (this.infolist.FDID.match(/^[ ]*$/)) {
					this.$Message.error("店铺信息不能为空！");
					return;
				}
				newinfo.FDID = this.infolist.FDID;
				if (newinfo.KHMC.match(/^[ ]*$/)) {
					this.$Message.error("客户名称不能为空！");
					return;
				}
				if (!reg.test(newinfo.Phone1)) {
					this.$Message.error("客户电话不规范！");
					return;
				}
				// 登录名赋值手机号
				
			if (!this.info && this.infolist.LoginName.match(/^[ ]*$/)) {
				this.infolist.LoginName = newinfo.Phone1				
				if(!this.info && this.infolist.LoginName.match(/^[ ]*$/) )
				{
			//	console.log(parsePinyin);
				this.infolist.LoginName =window.parsePinyin(newinfo.KHMC)+(parseInt(Math.random()*100)).toString(3);
			this.infolist.LoginName=this.filterStr(this.infolist.LoginName);
				}
				}
				// if (newinfo.Address.match(/^[ ]*$/)) {
				// 	this.$Message.error("客户详细地址不能为空！");
				// 	return;
				// }
				if (newinfo.City.match(/^[ ]*$/)) {
					this.$Message.error("客户城市不能为空！");
					return;
				}
				if (newinfo.PriceType.match(/^[ ]*$/)) {
					this.$Message.error("客户价格类型不能为空！");
					return;
				}
				// if (newinfo.Balance.toString().match(/^[ ]*$/)) {
				// 	this.$Message.error("客户期初余额不能为空！");
				// 	return;
				// }
				if (newinfo.Pwd) {
					if (newinfo.Pwd.match(/^[ ]*$/)) {
						this.$Message.error("客户登录密码不能为空！");
						return;
					}
				}
				this.$Modal.confirm({
					title: this.info ? "确定修改客户信息吗？" : "确定新建客户信息吗？",
					onOk: () => {
						if (this.imgurls.length !== 0) {
							let formdata = new FormData();
							formdata.append("file", this.imgurls[0].file);
							formdata.append("UserName", this.$fun.GetUserConstant().UserName);
							formdata.append("Prefix", this.$fun.GetUserConstant().Prefix);
							formdata.append("Token", this.$fun.GetUserConstant().Token);
							formdata.append("Type", "SFZ");
							let that = this;
							var xhr = new XMLHttpRequest();
							xhr.open("post", "http://8.131.84.184:8022/imgapi/Image/UploadImg");
							xhr.send(formdata);
							xhr.onload = function() {
								if (xhr.status == 200) {
									let res = JSON.parse(JSON.parse(xhr.responseText));
									if (res.status == "SUCCESS") {
										that.infolist.IDCard = that.infolist.IDCard.concat(res.data.URL.URL)
										that.fnCreatUserInfo()
									} else {
										that.$XModal.alert(res.msg)
									}
								} else {
									that.$XModal.alert("服务器或操作出现错误！")
								}
							};
						} else {
							this.fnCreatUserInfo()
						}
					}
				})
			},

			fang(file, index) {
				let that = this;
				let src = "";
				let srcurl = "";
				lrz(file.path[0].files[0], { quality: 0.7 }).then(function(rst) {
					that.newfile = rst.origin
					srcurl = rst
					console.log(rst)
					console.log(srcurl)
				}).catch(function(error) {
					//失败时执行
				}).always(function() {
					//不管成功或失败，都会执行
				});
				// if(that.infolist.IDCard==''){
				// 	var mfiles = i.path[0].files[0];
				setTimeout(() => {
					if (srcurl.origin.size > 14011669) {
						that.$XModal.alert("图片内存大小超出限制，请重新选择！");
						return;
					}
					that.imgurls.push({
						imgurl: srcurl.base64,
						file: that.newfile,
					});
				}, 800);
			},

			delateurl() {
				this.infolist.IDCard = "";
				this.imgurls = [];
			},

			fnCreatSalesMan(data) {
				this.infolist.ZGID = data.ZGID;
				this.infolist.ZGMC = data.ZGMC;
			},
		},
	};
</script>

<style lang="less" scoped>
	.goodsview {
		display: flex;

		.modelbox {
			width: 100%;
			min-height: 480px;
			flex-wrap: wrap;

			.itemleft {
				width: 100%;
			}

			.itemright {
				width: 100%;
			}

			.infowrap {
				width: 100%;
				height: 45px;
				display: flex;
				font-size: 14px;
				align-items: center;
				color: #000;

				.itemwrap {
					width: 35%;
					height: 40px !important;
				}

				.itemwrap>div {
					margin-left: auto;
				}

				.itemdesc {
					color: red;
				}
			}
		}

		.oSpan {
			font-size: 14px;
			font-family: Microsoft YaHei;
			font-weight: bold;
			color: #333333;
		}

		.imgbox {
			width: 100%;

			.imgwrap {
				display: flex;

				.imgicon {
					width: 60px;
					height: 60px;
					background: #ccc;
					margin: 10px;
					display: flex;
					justify-content: center;
					align-items: center;
					border-radius: 5px;
					position: relative;
					z-index: 0;

					.delate {
						display: flex;
						align-items: center;
						justify-content: center;
						position: absolute;
						background: #919191;
						right: -10px;
						top: -10px;
						color: #fff;
						font-size: 20px;
						border-radius: 100%;
						cursor: pointer;
					}

					input {
						width: 100%;
						height: 100%;
						opacity: 0;
						cursor: pointer;
					}
				}

				.imgitem {
					width: 100%;
					height: 100%;
					background-size: 100% !important;
				}

				.addinput {
					width: 60px;
					height: 60px;
					border: 1px solid #ccc;
					margin: 10px;
					display: flex;
					align-items: center;
					border-radius: 5px;
					position: relative;
					background: url(../../../assets/img/add.png) no-repeat center center;
					background-size: cover;

					.inputs {
						width: 100%;
						height: 100%;
						opacity: 0;
					}
				}
			}
		}

		.btnsumit {
			width: 150px;
			height: 35px;
			background: green;
			display: flex;
			justify-content: center;
			align-items: center;
			font-size: 16px;
			color: #fff;
			border-radius: 5px;
			cursor: pointer;
			-webkit-user-select: none;
		}

		.btnwrap {
			height: 60px;
			display: flex;
			justify-content: center;
			align-items: center;
		}
	}
</style>
